<template>
  <staggering-transition emitter="toggleSlideTransition">
    <h1
      :key="title"
      class="title"
      @click="click">
      {{title}}
    </h1>
  </staggering-transition>
</template>

<script>
import StaggeringTransition from '@/components/StaggeringTransition.vue';

export default {
  name: 'Title',
  components: { StaggeringTransition },
  data() {
    return {
      staggeringEnter: null,
    };
  },
  computed: {
    title() {
      return this.$store.getters.getCurrentPage.name;
    },
    path() {
      return this.$store.getters.getCurrentPage.path;
    },
    pathName() {
      return this.$store.getters.getCurrentPage.name;
    },

  },
  methods: {
    click() {
      if (!this.$store.state.slideInTransition) {
        if (this.$route.name !== this.pathName) {
          this.$router.push(this.path);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .title {
    text-transform: uppercase;
    min-height: 1em;

  cursor: pointer;
  }
</style>
